export default defineNuxtPlugin({
  name: 'auth',
})
